// Fase 2: naming dinámico según los módulos del tenant.
// clínico → "Pacientes"; S&C → "Atletas"; híbrido (ambos) → "Personas".

// Fase 5a: espejo del RBAC del backend (src/lib/rbac.ts).
// Roles clínicos ven expediente (episodios, SOAP, campos médicos);
// coach (S&C) y assistant (agenda) no.
const CLINICAL_ROLES = ["owner", "admin", "physio"];

export function isClinicalRole(role) {
  return CLINICAL_ROLES.includes(role);
}

export function subjectLabel(modules) {
  const m = modules || {};
  if (m.clinical && m.strength) return "Personas";
  if (m.strength) return "Atletas";
  return "Pacientes";
}

export function subjectLabelSingular(modules) {
  const m = modules || {};
  if (m.clinical && m.strength) return "Persona";
  if (m.strength) return "Atleta";
  return "Paciente";
}
